import { render, staticRenderFns } from "./NinePointNineResult.vue?vue&type=template&id=325405a0"
import script from "./NinePointNineResult.vue?vue&type=script&lang=js"
export * from "./NinePointNineResult.vue?vue&type=script&lang=js"
import style0 from "./NinePointNineResult.vue?vue&type=style&index=0&id=325405a0&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports